import brightProspectsBook from 'assets/images/brightProspectsBook.jpg';
import brightProspectsBookOverview from 'assets/images/booksOverview/brightProspectsBook.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const brilliantProspects = {
  book: {
    id: 'glaenzende-aussichten',
    format: FLIP_BOOKS,
    title: 'Brilliant prospects',
    subtitle: 'Why share prices will double - and when',
    videos: 'Erwin W. Heri',
    layoutAndProduction: 'Eric Marschall and Hanspeter Frey',
    scope: { pages: 14, videos: 11 },
    price: [0, 20],
    introductions: ['Introduction brilliant prospects'],
    image: brightProspectsBook,
    overviewImg: brightProspectsBookOverview,
  },
  bookIds: [29, 30],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 20], [30, 29]),
};

export default brilliantProspects;
